import { render, staticRenderFns } from "./RecipeStep2.vue?vue&type=template&id=f20806a0&scoped=true"
import script from "./RecipeStep2.vue?vue&type=script&lang=js"
export * from "./RecipeStep2.vue?vue&type=script&lang=js"
import style0 from "./RecipeStep2.vue?vue&type=style&index=0&id=f20806a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20806a0",
  null
  
)

export default component.exports